import { ScopeButton } from '@monorepo/shared-lib';
import { Col, Form, Spin, Typography } from 'antd';
import ECBlogo from 'assets/images/ECB-logo-small.png';
import { FormRangePicker } from 'components/Custom/datePicker';
import { LabelWrapper } from 'components/Custom/labels';
import { FormSelect } from 'components/Custom/selects';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const VatOverviewWrapper = styled.div`
  .overview-main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    //height: 85vh;
  }
`;

interface VatOverviewProps {
  loading: boolean;
  currencies: string[];
  generateTaxReport: (dateRange: Date[], currency: string) => void;
  form: any;
  onCurrencyChange?: (currency: string) => void;

  entityName?: string;
  taxReturnName?: string;
}
const { Text } = Typography;

interface FieldType {
  dateRange: Date[];
  currency: string;
}

export const VatOverview: React.FC<VatOverviewProps> = ({
  loading,
  currencies,
  generateTaxReport,
  form,
  onCurrencyChange,
  entityName,
  taxReturnName,
}) => {
  const { t } = useTranslation();

  const handleSubmit = (values: FieldType) => {
    generateTaxReport(values.dateRange, values.currency);
  };

  return (
    <Spin spinning={loading} size="large">
      <Form layout={'horizontal'} onFinish={handleSubmit} form={form}>
        <VatOverviewWrapper>
          <div className="overview-main tax-submission-stretch">
            <div>
              <Col
                span={24}
                style={{
                  borderBottom: '1px solid var(--color-border, #dbeae3)',
                  marginBottom: 30,
                  paddingBottom: 15,
                }}
              >
                <Text style={{ fontSize: 14, fontWeight: 700 }}>
                  {entityName}
                </Text>
                <br />
                <Text style={{ fontSize: 16, fontWeight: 400 }}>
                  {taxReturnName}
                </Text>
              </Col>
              <Col span={24}>
                <LabelWrapper>
                  <span className="label-text">
                    {t('organisation.choose-reporting-period')}
                  </span>
                </LabelWrapper>
                <Form.Item<FieldType>
                  name="dateRange"
                  rules={[
                    { required: true, message: t('common.required-field') },
                  ]}
                >
                  <FormRangePicker
                    hasValue={true}
                    format="DD/MM/YYYY"
                    width="100%"
                  />
                </Form.Item>
                <LabelWrapper>
                  <span className="label-text">
                    {t('vat-report.reporting-currency')}
                  </span>
                </LabelWrapper>
                <Form.Item<FieldType>
                  name="currency"
                  rules={[
                    { required: true, message: t('common.required-field') },
                  ]}
                >
                  <FormSelect
                    width="100%"
                    height="45px"
                    placeholder={t('vat-report.select-currency')}
                    optionFilterProp="children"
                    showSearch
                    onChange={onCurrencyChange}
                    bordercolor="var(--color-border, #dbeae3)"
                    bgcolor="var(--color-surface-raised, #FFFFFF)"
                    options={currencies.map((currency) => ({
                      label: currency,
                      value: currency,
                    }))} //@ts-ignore
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
            </div>
            <div>
              <Text style={{ fontSize: 11, fontWeight: 400 }}>
                {t('organisation.reporting-period-created-based-on-mapping')}
              </Text>

              <div style={{ display: 'flex', gap: 10, margin: '30px 0px' }}>
                <img src={ECBlogo} />
                <Text style={{ fontSize: 11, fontWeight: 400 }}>
                  {t('organisation.ecb-rate-note')}
                </Text>
              </div>
              <Form.Item>
                <ScopeButton width="100%" type="primary" htmlType="submit">
                  {t('organisation.generate')}
                </ScopeButton>
              </Form.Item>
            </div>
          </div>
        </VatOverviewWrapper>
      </Form>
    </Spin>
  );
};
